import { VehicleBaseViewModel } from '@ail/contracts-api'
import { useTranslation } from 'react-i18next'
import { NumberPlate } from '../../common/NumberPlate/NumberPlate'

export function VehicleDetailsComponent(props: { vehicle?: VehicleBaseViewModel }) {
  const { t } = useTranslation()
  const { vehicle } = props
  const make = vehicle?.makeName ?? ''
  const makeImage = make
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase()

  return (
    <div className="col-12 col-md-6 vehicleDetailsComponent">
      <div className="box-title">
        <span>
          <i className="icon-car"></i> {t('CAR_DETAILS')}
        </span>
        <NumberPlate licenseNumber={vehicle?.licensePlate?.licenseNumber} country={vehicle?.licensePlate?.country} />
      </div>
      <div className="box2">
        <div className="details">
          <div className="row">
            <div className="col-6">
              <div className="detailContent">
                {vehicle?.makeName &&
                vehicle.modelName &&
                vehicle.makeName.toLowerCase() !== 'dummy' &&
                vehicle.modelName.toLowerCase() !== 'dummy' ? (
                  <label>
                    {vehicle.makeName} {vehicle.modelName}
                  </label>
                ) : (
                  <label>{vehicle?.description}</label>
                )}
              </div>
              <div className="detailContent">
                <label>{t('MODEL')}</label>
                {vehicle?.typeName ?? '-'}
              </div>
              <div className="detailContent">
                <label>{t('VIN_NUMBER')}</label>
                {vehicle?.chassisNumber}
              </div>
            </div>
            <div className="col-6">
              {vehicle?.makeName && (
                <img src={`/img/makesLogos/${makeImage}.svg`} width="100%" height="100%" className="brandLogo" />
              )}
            </div>
            <div className="col-6">
              <div className="detailContent">
                <label>{t('MOTOR_NUMBER')}</label>
                {vehicle?.motorNumber?.match(/.{3}/g)?.join('.')}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
